import {
  ENTER_OTP_VALUE,
  OTP_SENT,
  get_request_config
} from '@/utils/system_constants/constant.js';
import axios from 'axios';
import OnboardingIndex from '../OnboardingIndex.vue';
import alert_mixin from '@/utils/mixins/alert_mixin';

const REQUESTOR_ROLE_MATCHERS = ['entity', 'requestor', 'requester'];
const OWNER_ROLE_MATCHERS = ['case owner', 'case_owner'];
const INTAKE_ROLE_MATCHERS = ['intake officer', 'intake_officer', 'intake desk'];
function normalize_role(role) {
  return String(role || '').trim().toLowerCase();
}

function normalize_text(value) {
  return String(value || '').trim();
}

function project_display_name(data = {}) {
  const values = [
    data?.project_name,
    data?.current_project_name,
    data?.selected_project_name,
    data?.project?.project_name,
    data?.project?.name,
    data?.current_project?.project_name,
    data?.current_project?.name
  ];
  return normalize_text(values.find(Boolean));
}

const is_requestor_role = (normalized_role) =>
  REQUESTOR_ROLE_MATCHERS.some((role_matcher) => normalized_role.includes(role_matcher));

const is_owner_role = (normalized_role) =>
  OWNER_ROLE_MATCHERS.some((role_matcher) => normalized_role.includes(role_matcher))
  || normalized_role === 'owner'
  || normalized_role.endsWith(' owner');

function is_intake_role(normalized_role) {
  return (
    INTAKE_ROLE_MATCHERS.some((role_matcher) => normalized_role.includes(role_matcher))
    || normalized_role === 'intake'
  );
}

function is_coordinator_role(normalized_role) {
  return normalized_role.includes('coordinator') || normalized_role === 'coord';
}

export default {
  name: 'OneTimePin',
  mixins: [alert_mixin],
  components: {
    OnboardingIndex
  },
  data() {
    return {
      title: "Verify Your Account",
      submit_button_text: "Login",
      verification_running: false,
      otp_number: '',
      otp_sending: false
    };
  },

  computed: {
    post_otp_route_name() {
      const normalized_role = normalize_role(this.$store.getters.currentRole);

      if (is_requestor_role(normalized_role)) {
        return 'RequestorPortal';
      }

      if (is_owner_role(normalized_role)) {
        return 'OwnerDashboard';
      }

      if (is_intake_role(normalized_role)) {
        return 'IntakeDesk';
      }

      if (is_coordinator_role(normalized_role)) {
        return 'ScopeDashboard';
      }

      return 'CompanyPortfolio';
    }
  },

  methods: {

    async handle_enter_otp() {
      this.verification_running = true;

      const data = {
        one_time_password: this.otp_number,
        user_id: this.$store.getters.currentUserId
      };

      try {
        const response = await axios.post(
          ENTER_OTP_VALUE,
          data,
          get_request_config()
        );

        const response_data =
          typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

        if (response_data.status === 'success') {
          const project_name = project_display_name(response_data);
          if (project_name) {
            this.$store.dispatch('setCurrentProjectName', project_name);
          }

          sessionStorage.setItem('otp_verified', 'true');
          this.show_success('OTP verified successfully');
          await this.$router.replace({ name: this.post_otp_route_name });
        } else {
          this.show_error(response_data.message || 'Error during OTP verification');
        }
      } catch (error) {
        this.show_error(
          error?.response?.data?.message || 'Please enter a valid OTP.'
        );
      } finally {
        this.verification_running = false;
      }
    },

    async resend_otp() {
      if (this.otp_sending) return;

      this.otp_sending = true;
      const user_id = this.$store.getters.currentUserId;

      try {
        const response = await axios.post(
          OTP_SENT,
          { user_id },
          get_request_config()
        );

        const response_data =
          typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

        if (response_data.status === 'success') {
          this.show_success('OTP has been resent successfully.');

          if (response_data.user_id) {
            this.$store.dispatch('setCurrentUserId', response_data.user_id);
          }
        } else {
          this.show_error(response_data.message || 'Could not send OTP.');
        }
      } catch (error) {
        this.show_error(
          error?.response?.data?.message || 'Could not send OTP to user.'
        );
      } finally {
        this.otp_sending = false;
      }
    }
  }
};
